import { render, staticRenderFns } from "./facultys.vue?vue&type=template&id=4a6d55fa&scoped=true"
import script from "./facultys.vue?vue&type=script&lang=js"
export * from "./facultys.vue?vue&type=script&lang=js"
import style0 from "./facultys.vue?vue&type=style&index=0&id=4a6d55fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d55fa",
  null
  
)

export default component.exports